import PARK_TYPES from '../../constants/parkTypes';

const reservationEng = {
  head: {
    zone: 'Zone'
  },
  parking: {
    places: {
      from: 'from',
      placesFree: 'vacant spaces',
      totalPlaces: 'Total places',
      forDisabled: 'Places for people with disabilities'
    },
    rate: 'rub/hr',
    startParking: 'Start parking',
    payParking: 'Pay for parking',
    free: 'Free'
  },
  parkomat: {
    title: 'Description'
  },
  days: {
    Рабочий: 'Weekday',
    Суббота: 'Saturday',
    Воскресенье: 'Sunday',
    Праздник: 'Holiday'
  },
  category: {
    Придорожная: 'On-street parking',
    Многоуровневая: 'Multi-level parking',
    Карман: 'Angle parking',
    Паркомат: 'Parking meter',
    [PARK_TYPES.PLANAR]: 'Planar',
    [PARK_TYPES.RESIDENT]: 'Resident parking',
    [PARK_TYPES.TAXI]: 'Taxi parking',
    [PARK_TYPES.BUS]: 'Tour buses parking',
    [PARK_TYPES.COMMERCE]: 'Commerce parking',
    [PARK_TYPES.RESIDENTZONE]: 'Resident zone',
    [PARK_TYPES.MUNICIPAL]: 'Municipal parking',
  },
  type: {
    'Уличная парковка': 'On-street parking',
    'Коммерческая парковка': 'Commerce parking',
    'Многоуровневая': 'Multi-level parking',
    'Плоскостная парковка': 'Planar parkign',
    'Парковка для такси': 'Taxi parking',
    'Парковка для автобусов': 'Tour buses parking',
    'Парковка для инвалидов': 'Angle parking',
    'Парковка для резидентов': 'Resident parking',
    'Муниципальная парковка': 'Municipal parking',

  },
  parkingOperator: {
    tyumenGorTrans: 'Parking operator: MSI "Тюменьгортранс"'
  }
};

const reservationRu = {
  head: {
    zone: 'Зона'
  },
  parking: {
    places: {
      from: 'из',
      placesFree: 'мест свободно',
      totalPlaces: 'Всего мест',
      forDisabled: 'Мест для инвалидов'
    },
    rate: 'руб/час',
    startParking: 'Начать парковку',
    payParking: 'Оплатить парковку',
    free: 'Бесплатно'
  },
  parkomat: {
    title: 'Описание'
  },
  days: {
    Рабочий: 'Рабочий',
    Суббота: 'Суббота',
    Воскресенье: 'Воскресенье',
    Праздник: 'Праздник'
  },
  category: {
    Придорожная: 'Придорожная',
    Многоуровневая: 'Многоуровневая',
    Карман: 'Карман',
    Паркомат: 'Паркомат',
    [PARK_TYPES.FREE]: 'Бесплатная',
    [PARK_TYPES.FORDISABLED]: 'Для инвалидов',
    [PARK_TYPES.PLANAR]: 'Плоскостная',
    [PARK_TYPES.RESIDENT]: 'Парковка для резидентов',
    [PARK_TYPES.TAXI]: 'Парковка для такси',
    [PARK_TYPES.BUS]: 'Парковка для автобусов',
    [PARK_TYPES.COMMERCE]: 'Коммерческая парковка',
    [PARK_TYPES.RESIDENTZONE]: 'Резидентная зона',
    [PARK_TYPES.MUNICIPAL]: 'Муниципальная парковка',
  },
  type: {
    'Уличная парковка': 'Уличная парковка',
    'Коммерческая парковка': 'Коммерческая парковка',
    'Многоуровневая': 'Многоуровневая',
    'Плоскостная парковка': 'Плоскостная парковка',
    'Муниципальная парковка': 'Муниципальная парковка',
  },
  parkingOperator: {
    tyumenGorTrans: 'Оператор парковки: МКУ "Тюменьгортранс"'
  }
};

export default {
  eng: reservationEng,
  ru: reservationRu
};
